webpackJsonp([191454632424336],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/weed-control.bcdddea6.jpg";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(19);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _landscapeDevelopment = __webpack_require__(28);
	
	var _landscapeDevelopment2 = _interopRequireDefault(_landscapeDevelopment);
	
	var _weedControl = __webpack_require__(129);
	
	var _weedControl2 = _interopRequireDefault(_weedControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WeedControl = function WeedControl() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Weed Control | ICE Enterprises'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subBackground' },
	      _react2.default.createElement('img', { src: _landscapeDevelopment2.default, alt: '' })
	    ),
	    _react2.default.createElement(
	      'header',
	      { className: 'sub' },
	      _react2.default.createElement(
	        'div',
	        { className: 'headerTitle' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Weed Control'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'pest control that attempts to halt noxious or injurious weeds..'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { className: 'col' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pagination' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Home'
	        ),
	        ' > ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/services' },
	          'Services'
	        ),
	        ' > Weed Control'
	      ),
	      _react2.default.createElement('img', { src: _weedControl2.default, alt: 'Weed Control project in Illinois' }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'halting weeds quickly, and thoroughly'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Weed control is a category of pest control that attempts to halt noxious or injurious weeds. While looking ugly, weeds can also compete with desired flora and fauna and cause complications. '
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'ICE utilizes only the highest quality pesticides in ALL projects. Other companies pesticides can take up to a week, Our solution ensures results in only 3 - 4 days. Our pesticides cover 120 - 170 different types of weeds versus the competitions 100 different types.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:estimates@ice2010.com', target: '__blank' },
	          'Contact us today'
	        ),
	        ' to learn more about our advanced weed control approach.'
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'caller' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact us today and learn more'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          null,
	          '(815) 271-0368'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', href: 'mailto:estimates@ice2010.com' },
	          'estimates@ice2010.com'
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { color: 'purple' })
	  );
	};
	
	exports.default = WeedControl;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-weed-control-js-f3724a52608bcbfbf4c0.js